export default __webpack_public_path__ + "static/media/pana.c8d7d1e6.svg";